import React from "react";
import { FormattedMessage } from "react-intl";
import logoFooter from "./../../../../app/assets/images/logo-footer-001-300x123.png";
import logoCodeciping from "./../../../../app/assets/images/codeciping_eur.png";
import logoDigiDEM from "../../../../app/assets/images/logoDigiDEM.png";
import "./scss/code.scss";

const FooterCode = () => {
  return (
    <>
      <div className="container-fluid" style={{ backgroundColor: "#E8E8E8" }}>
        <div className="container py-4">
          <p className="text-center mb-0 py-1">
            The crowdsourcing for the cities Brussels, Amsterdam, Podgorica and
            Berlin are under the DigiDem project, which is co-financed by the
            'Europe for citizens' program of the European Union.
          </p>
        </div>
      </div>

      <div className="container-fluid">
        <div className="container py-4">
          <p className="text-center mb-0 py-1">
            DigiDEM is a project co-funded by the Europe For Citizens programme
            of the European Union
            <br />
            <img className="mt-3" src={logoDigiDEM} alt="" height="55" />
          </p>
        </div>
      </div>

      <div className={`footer py-4 d-flex flex-lg-column`} id="kt_footer">
        <div className={`d-flex flex-column flex-md-row align-items-start`}>
          <div className="text-white order-md-1 footer-block">
            <div className="footer-block-header">
              <FormattedMessage id="CODE.FOOTER.1.HEADER" />
            </div>

            <img src={logoFooter} className="logo-iceland" />

            <p className="p-top">
              <a href={"/privacy"} target={"_blank"} className="text-white">
                <FormattedMessage id="CODE.POLICY_POLICY" />
              </a>
            </p>
          </div>

          <div className="text-white order-md-2 footer-block">
            <div className="footer-block-header">
              <FormattedMessage id="CODE.FOOTER.2.HEADER" />
            </div>

            <p className="p-top">
              <FormattedMessage id="CODE.FOOTER.2.PROMO" />
            </p>

            <a
              href={"https://code-europe.onesource.pt/en/project"}
              target={"_blank"}
            >
              <img src={logoCodeciping} className="logo-codeciping" />
            </a>
          </div>

          <div className="text-white order-md-3 footer-block">
            <div className="footer-block-header">
              <FormattedMessage id="CODE.FOOTER.3.HEADER" />
            </div>

            <p className="p-top">
              Elisa Lironi, ECAS,
              <br />
              <a
                href={"mailto:elisa.lironi@codecidingeurope.eu"}
                className="text-white link-email"
              >
                elisa.lironi@codecidingeurope.eu
              </a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default FooterCode;
